// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".destaque-item {\n  font-size: 18px;\n  color: #008e9e;\n}\n\n.comissoes {\n  display: flex;\n  flex-direction: column;\n  width: 240px;\n}\n.comissoes > div {\n  margin-top: 8px;\n  display: flex;\n  align-items: center;\n  border-bottom: 1px solid #ccc;\n}\n.comissoes > div span {\n  margin-right: 8px;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
